import { createContext, useContext } from "react";

/** A click on one row's "expand / collapse all details": `version` changes on every click, so repeating it still acts. */
export interface IEntityNestedCommand {
  isExpanded?: boolean;
  version: number;
}

export const EntityNestedCommandContext = createContext<IEntityNestedCommand>({
  version: 0,
});

export const useEntityNestedCommand = (): IEntityNestedCommand =>
  useContext(EntityNestedCommandContext);
